/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminServiceAvailabilityDay,
  AdminV1OrganizationsPaymentsServiceRatesInstructorsAvailabilityListParams
} from '.././model';

import adminV1OrganizationsPaymentsServiceRatesInstructorsAvailabilityListMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * List availability slots for a service rate and instructor for each day within the given date range. Optionally filter by facility asset ID to show availability for specific asset only. Requires admin access scoped to the organization. Days with no slots will be included with an empty slots list.
 * @summary List availability slots for a service rate and instructor for each day within the given date range. Optionally filter by facility asset ID to show availability for specific asset only. Requires admin access scoped to the organization. Days with no slots will be included with an empty slots list.
 */
export const adminV1OrganizationsPaymentsServiceRatesInstructorsAvailabilityList = (
    organizationId: number,
    serviceRateId: string,
    instructorId: string,
    params: AdminV1OrganizationsPaymentsServiceRatesInstructorsAvailabilityListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsServiceRatesInstructorsAvailabilityListMutator<AdminServiceAvailabilityDay[]>>,) => {
      return adminV1OrganizationsPaymentsServiceRatesInstructorsAvailabilityListMutator<AdminServiceAvailabilityDay[]>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/service-rates/${serviceRateId}/instructors/${instructorId}/availability/`, method: 'GET',
        params
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsServiceRatesInstructorsAvailabilityListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsServiceRatesInstructorsAvailabilityList>>>
